let hasAcceptedCatsCheck = false
let hasAcceptedDogsCheck = false

if ( localStorage.getItem( 'hasAcceptedCatsCheck' ) ) {
	hasAcceptedCatsCheck = true
}

if ( localStorage.getItem( 'hasAcceptedDogsCheck' ) ) {
	hasAcceptedDogsCheck = true
}

const initialState = {
	loadedScripts: [],
	menuIsOpen: false,
	hasSidebar: true,
	hasAcceptedCatsCheck: hasAcceptedCatsCheck,
	hasAcceptedDogsCheck: hasAcceptedDogsCheck
}

export default function reducer( state = initialState, action ) {
	const { payload } = action

	switch ( action.type ) {
		case 'ADD_SCRIPT':
			return {
				...state,
				loadedScripts: [
					...state.loadedScripts,
					action.value
				]
			}

		case 'OPEN_MENU':
			return Object.assign( {}, state, {
				menuIsOpen: true
			})

		case 'CLOSE_MENU':
			return Object.assign( {}, state, {
				menuIsOpen: false
			})

		case 'SET_SIDEBAR_VISIBILITY':
			return Object.assign( {}, state, {
				hasSidebar: payload
			})

		case 'ACCEPT_CAT_CHECK':
			return Object.assign( {}, state, {
				hasAcceptedCatsCheck: true
			})

		case 'ACCEPT_DOG_CHECK':
			return Object.assign( {}, state, {
				hasAcceptedDogsCheck: true
			})
	}

	return state
}



// WEBPACK FOOTER //
// ./redux/reducers/site.jsx